import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import nonEmpty from '../utils/nonEmpty';

const ACTIVITIES_POST_TOPICS_TOPICS_FRAGMENT = gql(`
  fragment activitiesPostTopics_topics on Topic {
    id
    name
  }
`);

const activitiesPostTopics = (
  postTopics:
    | (DocumentType<typeof ACTIVITIES_POST_TOPICS_TOPICS_FRAGMENT> | null)[]
    | null = [],
) => {
  const topics = postTopics?.filter(nonEmpty);
  if (!topics) {
    return null;
  }

  const firstTopic = topics[0];
  if (!firstTopic) return null;

  if (topics.length <= 2) {
    return `in: ${topics.map((topic) => topic.name).join(', ')}`;
  }

  return `in: ${firstTopic.name} and ${topics.length - 1} more`;
};

export default activitiesPostTopics;
